import {
  WiseOwlBlock,
  WiseOwlBlockType,
  WiseOwlBlockDisplayType,
  wiseOwlViewCopy,
  WiseOwlLoadingConfiguration,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

/**
 * These exact prompts are subject to change, and the way we
 * determine these prompts will change post-MLP, where they'll no longer be static
 * consider this temporary.
 */
const recommendedPrompts: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.PromptSuggestionGroup,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      categories: [
        {
          name: wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
            .name,
          suggestions: [
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.first,
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.second,
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.third,
          ],
        },
        {
          name: wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.name,
          suggestions: [
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .first,
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .second,
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .third,
          ],
        },
      ],
    },
  },
];

const defaultLoadingState: WiseOwlLoadingConfiguration = {
  submission: false,
  fetchChatById: false,
};

const wiseOwlElementIds = {
  WISE_OWL_CONTAINER: "WISE_OWL_CONTAINER",
};

export { defaultLoadingState, wiseOwlElementIds };
